import { Grid2, Box, Typography, IconButton } from "@mui/material"
import { useRef } from "react"
import LeaderWebViewStyles from "./LeaderWebView.module.css"
import Narayana from "../../../ui-utils/latestPics/Narayana.png"
import Roshni from "../../../ui-utils/latestPics/Roshni.svg"
import Manaorama from "../../../ui-utils/latestPics/Manaorama.svg"
import en from "../../../i18n/English/Aboutus/founders.json";
import hi from "../../../i18n/Hindi/Aboutus/founders.json";
import kn from "../../../i18n/Kannada/Aboutus/founders.json";
import gu from "../../../i18n/Gujarati/Aboutus/founders.json";
import ma from "../../../i18n/Marathi/Aboutus/founders.json";
import { useLanguage } from "../../../Context/LangContext";
export default function WebView(){
    const backRef1 = useRef(null);
         const { language } = useLanguage();
         const translations = { en, hi, kn ,gu,ma };
       const t = translations[language] || translations.en ;
    return (
        <>

            <Grid2 className={LeaderWebViewStyles.outerCard}>
               <Grid2 className={LeaderWebViewStyles.title_card}>
                    {/* <Typography className={LeaderWebViewStyles.leader_title} sx={{ fontWeight: 600 }}>

                            {t.heading}
                            </Typography> */}

                    <div className={LeaderWebViewStyles.headingContainer}>
                        <div className={LeaderWebViewStyles.gradientBackground}></div>
                        <Typography className={LeaderWebViewStyles.leader_title} style={{ fontWeight: 600 }}>
                            {t.heading}
                        </Typography>
                    </div>
               </Grid2>



                            <Grid2 className={LeaderWebViewStyles.inner_card}>

                    <Grid2 className={LeaderWebViewStyles.flip_card}
                        onMouseEnter={() => {
                            if (backRef1.current) {
                                backRef1.current.scrollTop = 0;
                            }
                        }}>
                        <Grid2 className={LeaderWebViewStyles.flip_card_inner}>
                            {/* Front Side */}
                            <Grid2 className={LeaderWebViewStyles.flip_card_front}>
                                <img src={Narayana} alt="leaderpic" className={LeaderWebViewStyles.picture} />
                                <Typography className={LeaderWebViewStyles.ex_subtit} >{t.founders[0].name}</Typography>
                                <Typography className={LeaderWebViewStyles.ex_subtit1}>{t.founders[0].designation}</Typography>
                                {/* <Typography  className={LeaderWebViewStyles.ex_subtit2}>
                                    Mr. Shetty is a seasoned professional,
                                    possessing over more than four decades of
                                    experience...
                                </Typography> */}
                            </Grid2>
                            {/* Back Side */}
                            <Grid2 className={LeaderWebViewStyles.flip_card_back1} >
                                <div className={LeaderWebViewStyles.flip_back_content} ref={backRef1} tabIndex={0} role="region" aria-label={`Founder profile details`}>
                                <Typography className={LeaderWebViewStyles.ex_subtitback}>{t.founders[0].name}</Typography>
                                <Typography className={LeaderWebViewStyles.ex_subtit1back}>{t.founders[0].designation}</Typography>
                                <Typography className={LeaderWebViewStyles.ex_subtit2back}>
                                    <span className={LeaderWebViewStyles.span} style={{ fontWeight: 600 }}>{t.founders[0].name1}</span>{t.founders[0].description}
                                </Typography>
                                </div>
                            </Grid2>
                        </Grid2>
                    </Grid2>

                    {/* Card 2 */}
                    <Grid2 className={LeaderWebViewStyles.flip_card}>
                        <Grid2 className={LeaderWebViewStyles.flip_card_inner}>
                            {/* Front Side */}
                            <Grid2 className={LeaderWebViewStyles.flip_card_front}>
                                <img src={Manaorama} alt="leaderpic" className={LeaderWebViewStyles.picture} />
                                <Typography className={LeaderWebViewStyles.ex_subtit}>{t.founders[1].name}</Typography>
                                <Typography className={LeaderWebViewStyles.ex_subtit1}>{t.founders[1].designation}</Typography>
                                {/* <Typography className={LeaderWebViewStyles.ex_subtit2}>
                                    Mrs. Manaorama N. Shetty is a seasoned
                                    Investor and possessing over three decades
                                    of experience...
                                </Typography> */}
                            </Grid2>
                            {/* Back Side */}
                            <Grid2 className={LeaderWebViewStyles.flip_card_back}>
                                <Typography className={LeaderWebViewStyles.ex_subtitback}>{t.founders[1].name}</Typography>
                                <Typography className={LeaderWebViewStyles.ex_subtit1back}>{t.founders[1].designation}</Typography>
                                <Typography className={LeaderWebViewStyles.ex_subtit2back}>
                                    <span className={LeaderWebViewStyles.span} style={{ fontWeight: 600 }}>{t.founders[1].name1}</span>{t.founders[1].description}
                                </Typography>
                            </Grid2>
                        </Grid2>
                    </Grid2>
                    {/* Card 3 */}
                    <Grid2 className={LeaderWebViewStyles.flip_card}>
                        <Grid2 className={LeaderWebViewStyles.flip_card_inner}>
                            {/* Front Side */}
                            <Grid2 className={LeaderWebViewStyles.flip_card_front}>
                                <img src={Roshni} alt="leaderpic" className={LeaderWebViewStyles.picture} />
                                <Typography className={LeaderWebViewStyles.ex_subtit}>{t.founders[2].name}</Typography>
                                <Typography className={LeaderWebViewStyles.ex_subtit1}>{t.founders[2].designation}</Typography>
                            </Grid2>
                            {/* Back Side */}
                            <Grid2 className={LeaderWebViewStyles.flip_card_back}>
                                <Typography className={LeaderWebViewStyles.ex_subtitback}>{t.founders[2].name}</Typography>
                                <Typography className={LeaderWebViewStyles.ex_subtit1back}>{t.founders[2].designation}</Typography>
                                <Typography className={LeaderWebViewStyles.ex_subtit2back}>
                                    <span className={LeaderWebViewStyles.span} style={{ fontWeight: 600 }}>{t.founders[2].name1}</span>{t.founders[2].description}
                                </Typography>
                            </Grid2>
                        </Grid2>
                    </Grid2>


                            </Grid2>

                </Grid2>

    </>
    )
}